import TrainingGrid from './RetainGrid';

export default TrainingGrid;
